// Class: starling.utils.Max

var $global = typeof window != "undefined" ? window : typeof global != "undefined" ? global : typeof self != "undefined" ? self : this

$global.Object.defineProperty(exports, "__esModule", {value: true});

var __map_reserved = {};

// Imports

var $hxClasses = require("./../../hxClasses_stub").default;

// Constructor

var Max = function(){}

// Meta

Max.__name__ = ["starling","utils","Max"];
Max.prototype = {
	
};
Max.prototype.__class__ = Max.prototype.constructor = $hxClasses["starling.utils.Max"] = Max;

// Init



// Statics


Max.MAX_VALUE = 1.79e+308
Max.MIN_VALUE = 5e-324
Max.INT_MAX_VALUE = 2147483647
Max.INT_MIN_VALUE = -2147483647
Max.UINT_MAX_VALUE = -1

// Export

exports.default = Max;


//////////////////
// WEBPACK FOOTER
// ./lib/_gen/starling/utils/Max.js
// module id = 338
// module chunks = 0